<div class="scrollable-section" #scrollableSection>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp(null)">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
      <div class="steps-container">
        <p class="steps-title">Pasos para importar desde Excel:</p>
        <p>1. Obtener la plantilla desde el botón "Descargar plantilla"</p>
        <p>2. Cumplimentar dicha plantilla</p>
        <p>3. Subir la plantilla cumplimentada y pulsar el botón "{{importButtonText}}"</p>
      </div>

      <div class="button-container">
        <button class="btn btn-fill btn-primary mx-auto" type="button" (click)="downloadTemplate(data.templateType)">
          <fa-icon [icon]="['fas', 'file-download']" style="margin-right: 1em;"></fa-icon>
          Descargar plantilla

        </button>
      </div>

      <!-- Sección de arrastrar y soltar o seleccionar archivo -->
      <div class="drag-drop-container" (drop)="onFileDropped($event)" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" [class.dragging]="isDragging" (click)="fileInput.click()">
        <p>Arrastra un archivo aquí o <span class="clickable">haz clic para
            seleccionar</span>.</p>
        <input #fileInput type="file" (change)="onFileSelected($event)" hidden accept=".xls, .xlsx" />
      </div>

      <div class="loaded-doc-container" *ngIf="validatingDoc">
        <div class="progress custom-progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100" [style.width.%]="progressValue">
          </div>
        </div>
        <span class="progress-bar-text">{{ progressText }}</span>
      </div>

      <div class="loaded-doc-container" *ngIf="loadedDoc.filename">
        <div class="loaded-doc-name-container">
          <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
          <p class="loaded-doc-name">{{ loadedDoc.filename }}</p>
          <button class="btn btn-fill btn-primary mx-auto btn-danger loaded-doc-delete" type="button"
            (click)="removeLoadedDoc()">
            <fa-icon [icon]="['fas', 'trash']"></fa-icon>
          </button>
        </div>
      </div>

      <div class="button-container" *ngIf="loadedDoc.filename">
        <button *ngIf="data.templateType === 'users'" class="btn btn-fill btn-primary mx-auto my-2" type="button"
          (click)="onImport(data.templateType)">
          <fa-icon [icon]="['fas', 'user-plus']" style="margin-right: 1em;"></fa-icon>
          {{importButtonText}}
        </button>
        <button *ngIf="data.templateType === 'companies'" class="btn btn-fill btn-primary mx-auto my-2" type="button"
          (click)="onImport(data.templateType)">
          <fa-icon [icon]="['fas', 'building']" style="margin-right: 1em;"></fa-icon>
          {{importButtonText}}
        </button>
      </div>

      <div class="loaded-doc-container" *ngIf="importingDoc">
        <div class="progress custom-progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            [attr.aria-valuenow]="importingProgressValue" aria-valuemin="0" aria-valuemax="100"
            [style.width.%]="importingProgressValue">
          </div>
        </div>
        <span class="progress-bar-text">{{ importingProgressText }}</span>
      </div>



    </app-generic-panel>

  </div>




</div>